import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-wave-indicator',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './wave-indicator.component.html',
  styleUrls: ['./wave-indicator.component.scss']
})
export class WaveIndicatorComponent {
  dots = [0, 1, 2, 3];
}

